import { baseApi } from './api';
import { ApiResponse } from '../types';
import { CalendarEventsParams, CalendarEventsResponse } from '../types/calendar';

export const calendarApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getCalendarEvents: builder.query<ApiResponse<CalendarEventsResponse>, CalendarEventsParams>({
      query: params => {
        const searchParams = new URLSearchParams();
        searchParams.append('dateFrom', params.dateFrom);
        searchParams.append('dateTo', params.dateTo);

        if (params.projectIds && params.projectIds.length > 0) {
          params.projectIds.forEach(id => searchParams.append('projectIds', id));
        }

        if (params.eventTypes && params.eventTypes.length > 0) {
          params.eventTypes.forEach(type => searchParams.append('eventTypes', type));
        }

        return `/calendar/events?${searchParams.toString()}`;
      },
      providesTags: ['CalendarEvent'],
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetCalendarEventsQuery } = calendarApi;
